// extracted by mini-css-extract-plugin
export default {"scaleWrapper":"scaleDiff_scaleWrapper__isJAq","rectScale":"scaleDiff_rectScale__MxDoG","textMarker":"scaleDiff_textMarker__jVPqa","lineMarker":"scaleDiff_lineMarker__rvjHH"};